import { render, staticRenderFns } from "./StudentWork.vue?vue&type=template&id=02995f08&scoped=true"
import script from "./StudentWork.vue?vue&type=script&lang=js"
export * from "./StudentWork.vue?vue&type=script&lang=js"
import style0 from "./StudentWork.vue?vue&type=style&index=0&id=02995f08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02995f08",
  null
  
)

export default component.exports